import ColumnTypes from './columns/column-types';
import defaultColumn from './columns/generators/default-column';
import textColumn from './columns/generators/text-column';
import numericColumn from './columns/generators/numeric-column';
import dateColumn from './columns/generators/date-column';
import datetimeColumn from './columns/generators/datetime-column';
import linkColumn from './columns/generators/link-column';
import externalColumn from './columns/generators/external-column';
import componentColumn from './columns/generators/component-column';
import badgeColumn from './columns/generators/badge-column';
import buttonColumn from './columns/generators/button-column';
import checkboxColumn from './columns/generators/checkbox-column';
import nestedColumn from './columns/generators/nested-column';
import paymentCardColumn from './columns/generators/payment-card-column';
import complexColumn from './columns/generators/complex-column';

const columnTypeRenderMap = {
    [ColumnTypes.text]: textColumn,
    [ColumnTypes.link]: linkColumn,
    [ColumnTypes.numeric]: numericColumn,
    [ColumnTypes.date]: dateColumn,
    [ColumnTypes.datetime]: datetimeColumn,
    [ColumnTypes.external]: externalColumn,
    [ColumnTypes.component]: componentColumn,
    [ColumnTypes.badge]: badgeColumn,
    [ColumnTypes.button]: buttonColumn,
    [ColumnTypes.checkbox]: checkboxColumn,
    [ColumnTypes.nested]: nestedColumn,
    [ColumnTypes.complex]: complexColumn,
    [ColumnTypes['payment-card']]: paymentCardColumn,
};

/**
 * Render a grid tbody cell based on the `cachedColumn.type`. Falls back to a
 * `defaultColumn` if the type is not supported.
 * @param {CachedColumn} cachedColumn
 * @param {Object} rowData
 * @param {Function} createElement
 * @param {Object} grid
 * @returns {*}
 */
export default function renderBodyCell({
    cachedColumn, rowData, createElement, grid,
}) {
    const params = {
        cachedColumn, rowData, createElement, grid, columnTypeRenderMap,
    };
    if (cachedColumn.type in columnTypeRenderMap) {
        return createElement(...columnTypeRenderMap[cachedColumn.type](params));
    }
    // fallback to default column rendering
    return createElement(...defaultColumn(params));
}
